import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const EngagementAchievementBox = ({ date, count, icon, title, user, content }) => {
  const theme = useTheme();
  const formattedDate = new Date(date).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  // Add ordinal suffix (st, nd, rd, th)
  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  const day = new Date(date).getDate();
  const dateWithOrdinal = formattedDate.replace(/^(\d+)/, getOrdinal(day));

  return (
    <Box
      sx={{
        border: "1.5px solid",
        borderColor: theme.palette.border.brand,
        borderRadius: 2,
        px: theme.containers.paddingMobile,
        py: theme.customSpacing.md,
        display: "flex",
        flexDirection: "column",
        gap: 0.5,
        backgroundColor: "transparent",
        color: "#fff",
        maxWidth: 280,
        [theme.breakpoints.down("md")]: {
          maxWidth: "100%"
        },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Box>{icon}</Box>
        <Typography
          sx={{
            fontWeight: theme.typography.fontWeightRegular,
            fontSize: theme.typography.textSM.fontSize,
          }}
        >
          {title}
        </Typography>
      </Box>
      <Typography
        sx={{
          fontSize: theme.typography.textXS.fontSize,
          color: theme.palette.text.gray,
        }}
      >
        {user && (<>{user}</>)}
        {date ? dateWithOrdinal : ""}
        
        {content && <>{content}</>}
        {!content && <span style={{ fontWeight: 500 }}> : {count} sessions</span>}
      </Typography>
    </Box>
  );
};

export default EngagementAchievementBox;
